import { trpc } from './trpc';
import { inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';

type OutputRouter = inferRouterOutputs<AppRouter>;
export type DisputeListOutput = OutputRouter['disputes']['list'];
export type Dispute = DisputeListOutput['data'][number];
export type DisputeDetails = OutputRouter['disputes']['details'];

export function useDisputesList(
    params?: Parameters<typeof trpc.disputes.list.useQuery>[0]
) {
    return trpc.disputes.list.useQuery(params || { limit: 200 });
}

export function useDisputeDetails(id: string) {
    return trpc.disputes.details.useQuery({ id });
}
